module.exports = __webpack_public_path__ + "img/dcwq.45a27c1a.png";